<!-- Loading Spinner -->
@if (isLoading) {
<div class="d-flex justify-content-center align-items-center py-5">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
}

<!-- Search Bar -->
@if (!isLoading) {
<div class="d-flex justify-content-between booking-id-search mb-0 align-items-center">
    <div>
        <h6 for="bookingId" class="form-label">Profile Edit @if(schoolId){ - <span class="badge-booking-id">{{ schoolId
                }}</span>}</h6>
    </div>
    <div>
        <div class="input-group mb-1">
            <input type="text" class="form-control" placeholder="Search by booking ID..." [(ngModel)]="schoolId">
            <button class="btn btn-primary" type="button" (click)="onSearch()">
                <i class="fa fa-search"></i>
            </button>
        </div>
    </div>
</div>
}

<!-- CREATE Button -->
@if (!isLoading && createData) {
<div class="mb-1 mt-1 text-end">
    <button class="btn btn-success" (click)="openCreateModal(createModal)">
        <i class="fa fa-plus"></i> View Create Details
    </button>
</div>
}

<!-- UPDATE Data (show update logs first, each as a component) -->
@if (!isLoading) {
<div>
    <!-- 🔹 Parent Nav -->
    <ul ngbNav #parentNav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs custom-tabs mb-1">
        <!-- School Profile -->
        <li [ngbNavItem]="1">
            <a ngbNavLink><i class="fa fa-user" aria-hidden="true"></i>
                School Profile</a>
            <ng-template ngbNavContent>
                <!-- 🔹 Child Nav inside School Profile -->
                <ul ngbNav #childNav="ngbNav" (activeId)="1" class="nav nav-pills mb-1 custom-tabs-child">
                    <li [ngbNavItem]="1">
                        <a ngbNavLink><i class="fa fa-plus-square-o me-2" aria-hidden="true"></i>Create</a>
                        <ng-template ngbNavContent>
                            <div class="col-md-12 mb-3">
                                <div class="card shadow-sm h-100">
                                    <div class="card-body">
                                        <p class="card-text mb-1">
                                            <i class="fa fa-calendar-plus-o text-primary me-1"></i>
                                            <strong>Created At:</strong>
                                            {{ profileEditCreateData.created_at | timezone }}
                                        </p>
                                        <p class="card-text mb-1">
                                            <i class="fa fa-user-plus text-success me-1"></i>
                                            <strong>Created By:</strong> {{ profileEditCreateData.email }}
                                        </p>
                                        <div class="card-text">
                                            <div class="bg-light rounded mt-1">
                                                <app-create-view [logData]="profileEditCreateData"></app-create-view>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2">
                        <a ngbNavLink><i class="fa fa-pencil-square-o me-2" aria-hidden="true"></i>Update</a>
                        <ng-template ngbNavContent>
                            <table class="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th>Updated At</th>
                                        <th>Updated By</th>
                                        <th>Changes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (log of profileEditUpdateData; track log) {
                                    @if (log.action === 'UPDATE') {
                                    <tr class="">
                                        <td>{{ log.updated_at | timezone }}</td>
                                        <td>
                                            {{ log.updated_by }}
                                            @if(log.updated_by === 'Task'){
                                            <ng-container>- {{ log.task_source }}</ng-container>
                                            }
                                        </td>
                                        <td>
                                            <pre><app-update-view [logData]="log.changed_fields"></app-update-view></pre>
                                        </td>
                                    </tr>
                                    }
                                    }
                                </tbody>
                            </table>
                        </ng-template>
                    </li>
                </ul>
                <!-- Render child nav -->
                <div [ngbNavOutlet]="childNav"></div>
                @if (!profileEditCreateData) {
                <div class="d-flex flex-column justify-content-center align-items-center" style="height: 120px;">
                    <i class="fa fa-info-circle text-muted mb-2" style="font-size: 2rem;"></i>
                    <span class="text-muted">No logs found</span>
                </div>
                }
            </ng-template>
        </li>

        <!-- Subscription -->
        <li [ngbNavItem]="2">
            <a ngbNavLink><i class="fa fa-usd" aria-hidden="true"></i>
                Subscription</a>
            <ng-template ngbNavContent>
                @for (sub of subscriptionGroupedData; track sub.helperId) {
                <div class="card mb-3">
                    <div class="card-header" (click)="sub.collapsed = !sub.collapsed">
                        <button class="btn btn-link text-decoration-none" type="button">
                            Subscription : {{ sub.createDate | timezone }}
                        </button>
                    </div>

                    <div [ngbCollapse]="sub.collapsed">
                        <div class="card-body">

                            <!-- 🔹 Inner Tabs for Create / Update Logs -->
                            <ul ngbNav #subNav="ngbNav" [(activeId)]="sub.activeTab" class="nav nav-pills mb-2 custom-tabs-child">
                                <li [ngbNavItem]="1">
                                    <a ngbNavLink><i class="fa fa-plus-square-o me-2" aria-hidden="true"></i>Create</a>
                                    <ng-template ngbNavContent>
                                        @if (sub.create.length > 0) {
                                        @for (log of sub.create; track log.id) {
                                        <div class="card mb-2 shadow-sm">
                                            <div class="card-body">
                                                <p><strong>Created At:</strong> {{ log.created_at | timezone }}</p>
                                                <p><strong>Created By:</strong> {{ log.created_by }}</p>
                                                <app-create-view [logData]="log.new_fields"></app-create-view>
                                            </div>
                                        </div>
                                        }
                                        } @else {
                                        <p class="text-muted">No Create Logs</p>
                                        }
                                    </ng-template>
                                </li>

                                <li [ngbNavItem]="2">
                                    <a ngbNavLink><i class="fa fa-pencil-square-o me-2" aria-hidden="true"></i>Update</a>
                                    <ng-template ngbNavContent>
                                        @if (sub.update.length > 0) {
                                        <table class="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Updated At</th>
                                                    <th>Updated By</th>
                                                    <th>Changes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (log of sub.update; track log.id) {
                                                <tr>
                                                    <td>{{ log.updated_at | timezone }}</td>
                                                    <td>
                                                        {{ log.updated_by }}
                                                        @if (log.updated_by === 'Task') {
                                                        <ng-container>- {{ log.task_source }}</ng-container>
                                                        }
                                                    </td>
                                                    <td>
                                                        <pre><app-update-view [logData]="log.changed_fields"></app-update-view></pre>
                                                    </td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                        } @else {
                                        <p class="text-muted">No Update Logs</p>
                                        }
                                    </ng-template>
                                </li>
                            </ul>

                            <!-- Render inner tab content -->
                            <div [ngbNavOutlet]="subNav"></div>

                        </div>
                    </div>
                </div>
                }


            </ng-template>

        </li>
    </ul>

    <!-- Render parent nav -->
    <div [ngbNavOutlet]="parentNav"></div>
</div>

}

<!-- CREATE Modal -->
<ng-template #createModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Create Details</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-create-view [logData]="createData"></app-create-view>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
</ng-template>